"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeGenerator = void 0;
const CalcBV = (n) => {
    return `${n * 4}px`;
};
const CalcFont = (n, unit = 'rem') => {
    return `${n / 16}${unit}`;
};
const Spaces = () => {
    const sizes = [0, 1, 2, 3, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32];
    const items = {};
    sizes.map((item, index) => (items[`sp${index}`] = `${CalcBV(item)}`));
    return items;
};
const breakpoints = {
    mobile: '320px',
    tablet: '768px',
    desktop: '1440px',
};
const typeGenerator = (primary, secondary, weight) => {
    const typeDefault = {
        family: {
            primary: primary || '"IBM Plex Sans", Times, Serif',
            secondary: secondary || '"IBM Plex Sans", Arial, Helverica, Sans-Serif',
        },
        weight: {
            heavy: '500',
            regular: '400',
            light: '300',
            strong: 'bold',
        },
    };
    const typePrimary = `
      font-family: ${typeDefault.family.primary};
      font-style: normal;
      font-weight: ${typeDefault.weight.regular};
      letter-spacing:  ${CalcBV(0)};
  `;
    const typeSecondary = `
      font-family: ${typeDefault.family.secondary};
      font-style: normal;
      font-weight: ${typeDefault.weight.regular};
      letter-spacing: ${CalcBV(0)};
  `;
    return Object.assign(Object.assign({}, typeDefault), { l1: `
      ${typePrimary}
      font-size: ${CalcFont(96)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.l1) || typeDefault.weight.heavy};
      line-height: ${CalcFont(104)};

      @media (min-width: ${breakpoints.tablet} ) {
        font-size: ${CalcFont(64)};
        line-height: ${CalcFont(72)};
      }
    `, l2: `
      ${typePrimary}
      font-size: ${CalcFont(72)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.l2) || typeDefault.weight.heavy};
      line-height: ${CalcFont(80)};

      @media (min-width: ${breakpoints.tablet} ) {
        font-size: ${CalcFont(48)};
        line-height: ${CalcFont(56)};
      }
    `, l3: `
      ${typePrimary}
      font-size: ${CalcFont(56)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.l3) || typeDefault.weight.heavy};
      line-height: ${CalcFont(64)};

      @media (min-width: ${breakpoints.tablet} ) {
        font-size: ${CalcFont(40)};
        line-height: ${CalcFont(48)};
      }
    `, l4: `
      ${typePrimary}
      font-size: ${CalcFont(40)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.l4) || typeDefault.weight.heavy};
      line-height: ${CalcFont(48)};

      @media (min-width: ${breakpoints.tablet} ) {
        font-size: ${CalcFont(32)};
        line-height: ${CalcFont(40)};
      }
    `, l5: `
      ${typeSecondary}
      font-size: ${CalcFont(32)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.l5) || typeDefault.weight.heavy};
      line-height: ${CalcFont(40)};

      @media (min-width: ${breakpoints.tablet} ) {
        font-size: ${CalcFont(24)};
        line-height: ${CalcFont(32)};
      }
    `, l6: `
      ${typeSecondary}
      font-size: ${CalcFont(24)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.l6) || typeDefault.weight.heavy};
      line-height: ${CalcFont(32)};

      @media (min-width: ${breakpoints.tablet} ) {
        font-size: ${CalcFont(20)};
        line-height: ${CalcFont(24)};
      }
    `, bodyLargeStandardRegular: `
      ${typeSecondary}
      font-size: ${CalcFont(16)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.bodyLargeStandardRegular) || typeDefault.weight.regular};
      line-height: ${CalcFont(24)};
    `, bodyLargeShortRegular: `
      ${typeSecondary}
      font-size: ${CalcFont(16)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.bodyLargeShortRegular) || typeDefault.weight.regular};
      line-height: ${CalcFont(20)};
    `, bodyMediumStandard: `
      ${typeSecondary}
      font-size: ${CalcFont(14)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.bodyMediumStandard) || typeDefault.weight.regular};
      line-height: ${CalcFont(24)};
    `, bodyMediumShort: `
      ${typeSecondary}
      font-size: ${CalcFont(14)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.bodyMediumShort) || typeDefault.weight.regular};
      line-height: ${CalcFont(16)};
    `, exceptionsAuxiliarRegular: `
      ${typeSecondary}
      font-size: ${CalcFont(12)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.exceptionsAuxiliarRegular) || typeDefault.weight.regular};
      line-height: ${CalcFont(16)};
    `, auxiliarMini: `
      ${typeSecondary}
      font-size: ${CalcFont(10)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.auxiliarMini) || typeDefault.weight.regular};
      line-height: ${CalcFont(16)};
    `, overline: `
      ${typeSecondary}
      font-size: ${CalcFont(10)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.overline) || typeDefault.weight.heavy};
      letter-spacing: 8%;
      line-height: ${CalcFont(16)};
      text-transform: uppercase;
    `, action: `
      ${typeSecondary}
      font-size: ${CalcFont(14)};
      font-weight: ${(weight === null || weight === void 0 ? void 0 : weight.action) || typeDefault.weight.heavy};
      line-height: ${CalcFont(16)};
      text-transform: uppercase;
  ` });
};
exports.typeGenerator = typeGenerator;
exports.default = {
    name: 'Flora 2.0',
    spaces: Spaces(),
    type: Object.assign({}, (0, exports.typeGenerator)()),
    colors: {
        build: {
            brand: {
                primary: '#626CC3',
                secondary: '#EE5D3D',
                tertiary: '#222222',
            },
            dark: {
                default: '#000000',
                light: '#000000',
            },
            light: {
                default: '#FFFFFF',
                dark: {
                    primary: '#F5F5F5',
                    secondary: '#FFFFFF',
                },
            },
            medium: {
                default: '#878787',
                light: {
                    primary: '#515151',
                    secondary: '#CCCCCC',
                },
            },
            gradient: {
                primary: {
                    first: '#626CC3',
                    end: '#626CC3',
                },
                secondary: {
                    first: '#EE5D3D',
                    end: '#EE5D3D',
                },
            },
        },
        action: {
            conversion: {
                static: '#0CC841',
                highlight: '#008626',
                disabled: 'rgba(0, 0, 0, 0.16)',
            },
            navigation: {
                standard: {
                    static: '#626CC3',
                    highlight: '#000F99',
                    disabled: 'rgba(0, 0, 0, 0.16)',
                },
                alt: {
                    static: '#FFFFFF',
                    highlight: '#000000',
                    disabled: 'rgba(255, 255, 255, 0.24)',
                },
            },
            gradient: {
                conversion: {
                    first: '#0CC841',
                    end: '#0CC841',
                },
                navigation: {
                    first: '#626CC3',
                    end: '#626CC3',
                },
            },
        },
        status: {
            success: {
                standard: '#0DAB01',
                alt: '#70DD67',
            },
            alert: {
                standard: '#FF9700',
                alt: '#FBC679',
            },
            error: {
                standard: '#DE1616',
                alt: '#FF6666',
            },
        },
        support: {
            whatsapp: '#128C7E',
            facebook: '#0078FF',
        },
        assorted: {
            assorted1: '#FF0801',
            assorted2: '#FF5501',
            assorted3: '#E29500',
            assorted4: '#A7B820',
            assorted5: '#6CD115',
            assorted6: '#20AE43',
            assorted7: '#1FA685',
            assorted8: '#49B1BF',
            assorted9: '#1B57CE',
            assorted10: '#7E15E3',
            assorted11: '#FF01B1',
            assorted12: '#FF0162',
        },
    },
    decoration: {
        radius: {
            sharp: `${CalcBV(0)}`,
            small: `${CalcBV(1)}`,
            medium: `${CalcBV(2)}`,
            large: `${CalcBV(4)}`,
            pill: '100%',
        },
        border: {
            hardline: `${CalcBV(0.25)}`,
            thin: `${CalcBV(0.5)}`,
            medium: `${CalcBV(0.75)}`,
            thick: `${CalcBV(1)}`,
        },
    },
    effects: {
        shadow: {
            down: {
                close: '0px 4px 4px 0px rgba(0, 0, 0, 0.16)',
                far: '0px 8px 24px 0px rgba(0, 0, 0, 0.4)',
                mid: '0px 4px 16px 0px rgba(0, 0, 0, 0.32)',
                soft: '0px 4px 20px 0px rgba(0, 0, 0, 0.12)',
            },
            up: {
                close: '0px -4px 4px 0px rgba(0, 0, 0, 0.16)',
                far: '0px -8px 24px 0px rgba(0, 0, 0, 0.4)',
                mid: '0px -4px 16px 0px rgba(0, 0, 0, 0.32)',
                soft: '0px -4px 20px 0px rgba(0, 0, 0, 0.12)',
            },
            left: {
                close: '-4px 0px 4px 0px rgba(0, 0, 0, 0.16)',
                far: '-8px 0px 24px 0px rgba(0, 0, 0, 0.4)',
                mid: '-4px 0px 16px 0px rgba(0, 0, 0, 0.32)',
                soft: '-4px 0px 20px 0px rgba(0, 0, 0, 0.12)',
            },
            right: {
                close: '4px 0px 4px 0px rgba(0, 0, 0, 0.16)',
                far: '8px 0px 24px 0px rgba(0, 0, 0, 0.4)',
                mid: '4px 0px 16px 0px rgba(0, 0, 0, 0.32)',
                soft: '4px 0px 20px 0px rgba(0, 0, 0, 0.12)',
            },
            center: {
                close: '0px 0px 4px 0px rgba(0, 0, 0, 0.16)',
                far: '0px 0px 24px 0px rgba(0, 0, 0, 0.4)',
                mid: '0px 0px 16px 0px rgba(0, 0, 0, 0.32)',
                soft: '0px 0px 20px 0px rgba(0, 0, 0, 0.12)',
            },
        },
    },
    breakpoints,
};
